// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Header_mainHeading__3Wa7_","text":"Header_text__JpOe5","textFirst":"Header_textFirst__2TQ5p","gif":"Header_gif__20r9d"};